// BARIQUE shared catalog utilities. Public catalog data is loaded from MongoDB at runtime.
export const CATEGORIES = [];
export const PRODUCTS = [];
export const findProduct = () => undefined;
export const bySection = () => [];
export const byCategory = () => [];
export const formatPrice = (p) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(p) || 0);

export const SWATCH_MAP = {
  ivory:"#EFEBE2", blush:"#E8CFC8", crimson:"#7F1E23", gold:"#B79764",
  onyx:"#141414", champagne:"#D9C7A7", rani:"#8A1538", navy:"#1E2A3C",
  emerald:"#0F5132", marigold:"#D97F1E", sand:"#D9CFB8", midnight:"#0E1729",
  black:"#0A0A0A", white:"#F9F9F6", red:"#B23A48", pink:"#D98BAA",
  green:"#3E5C4A", blue:"#3A5A83", silver:"#C7C9CC", copper:"#B4632F",
};

export const parseSwatch = (raw) => {
  if (!raw) return { name: "", hex: "#CCCCCC" };
  const s = String(raw);
  const pipe = s.indexOf("|");
  if (pipe > -1) return { name: s.slice(0, pipe), hex: s.slice(pipe + 1) || "#CCCCCC" };
  if (s.startsWith("#")) return { name: s, hex: s };
  const key = s.toLowerCase();
  return { name: s, hex: SWATCH_MAP[key] || "#CCCCCC" };
};
